import { MutationTree } from "vuex";
import { UserState } from "./types";

export const mutations: MutationTree<UserState> = {
    // 保存用户信息
    saveUserInfo(state, userInfo) {
        state = Object.assign(state, userInfo)
    },
    // 删除用户信息
    deleteUserInfo(state) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        state = Object.assign(state, {
            token: '',
            user: '',
            sys: [],
            sysIndex: 0
        })
    },
    // 切换平台
    changeSys(state, sys: number) {
        state = Object.assign(state, {
            sysIndex: sys
        })
    },
};
